import { HttpClient } from '@angular/common/http';
import { AppConfig } from '@s8l/client-tree-lib';

export interface Environment extends AppConfig {
  developer: boolean;
  logging: boolean;
  production: boolean;

  version: string;

  dashboard: string;
  dateFormat: string;
  dateTimeFormat: string;

  BACKEND_URL: string;
  UPDATE_WS: string;
  MEDIA_URL: string;
}

/* Common defaults for all environments */
const defaults: Partial<Environment> = {
  developer: false,
  logging: true,
  production: false,

  default_language: 'de',

  dashboard: 'min',
  dateFormat: 'mediumDate',
  dateTimeFormat: 'medium'
};

function makeURLs(ENV_URL: string) {
  const BACKEND_URL = `${window.location.origin}/api`;
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return {
    CMS_SERVER_URL: `${BACKEND_URL}/cms`,
    USER_SERVER_URL: `${BACKEND_URL}/user`,
    STREAMS_SERVER_URL: `${BACKEND_URL}/streams`,
    STATS_SERVER_URL: `${BACKEND_URL}/stats`,
    CONTENT_TREE_SERVER_URL: `${BACKEND_URL}/content-tree`,
    SHOPIFY_SERVER_URL: `${BACKEND_URL}/shopify`,
    BOOKING_SERVER_URL: `${BACKEND_URL}/booking`,
    VST_SERVER_URL: `${BACKEND_URL}/vst`,
    UPDATE_WS: `${wsProtocol}//${window.location.host}/api/cms/update`,
    QUIZ_DEFAULT_SERVER_URL: `${BACKEND_URL}/quiz-sp`,
    QUIZ_EXAM_SERVER_URL: `${BACKEND_URL}/quiz-exam`,
    QUIZ_REVIEW_SERVER_URL: `${BACKEND_URL}/quiz-review`,
    QUIZ_MULTIPLAYER_SERVER_URL: `${BACKEND_URL}/quiz-mp`,
    QUIZ_CASESTUDY_SERVER_URL: `${BACKEND_URL}/quiz-casestudy`,

    MEDIA_URL: `https://media-server.${ENV_URL}`
  };
}

export function mergeConfig(http: HttpClient, environment: any): Promise<Environment> {
  return http
    .get<any>('/config.json')
    .toPromise()
    .then(config => {
      return {
        ...defaults,
        ...environment,
        ...makeURLs(config.env_url),
        ...config
      };
    });
}
